import React, { useState } from 'react';
import { Button } from '../ui/button';
import { FileText, Palette } from 'lucide-react';
import { SimpleEditor } from './simple-editor';

type EditorMode = 'page' | 'edgeless';

interface DocumentEditorProps {
  documentId?: string;
  initialMode?: EditorMode;
  readonly?: boolean;
  className?: string;
}

export function DocumentEditor({ 
  documentId, 
  initialMode = 'page',
  readonly = false,
  className = ''
}: DocumentEditorProps) {
  const [mode, setMode] = useState<EditorMode>(initialMode);

  return (
    <div className={`flex flex-col h-full ${className}`}>
      {/* Mode Switch Toolbar */}
      {!readonly && (
        <div className="flex items-center gap-2 p-2 border-b bg-background">
          <Button
            variant={mode === 'page' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => setMode('page')}
            className="flex items-center gap-2"
          >
            <FileText className="w-4 h-4" />
            Page
          </Button>
          <Button
            variant={mode === 'edgeless' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => setMode('edgeless')}
            className="flex items-center gap-2"
          >
            <Palette className="w-4 h-4" />
            Edgeless
          </Button>
        </div>
      )}

      {/* Editor Container */}
      <div className="flex-1 overflow-hidden p-4">
        <SimpleEditor 
          className="h-full"
          placeholder={mode === 'page' ? 'Start writing your page...' : 'Create shapes and drawings on the canvas...'}
        />
      </div>
    </div>
  );
}